(function() {
  var AngularService,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AngularService = App.loadClass('core::Angular/Service');

  exports.SlackFilesService = (function(superClass) {
    extend(SlackFilesService, superClass);

    function SlackFilesService(http, $rootScope) {
      this.http = http;
      this.deleteFile = bind(this.deleteFile, this);
      this.getUsers = bind(this.getUsers, this);
      this.getFiles = bind(this.getFiles, this);
      this.saveToken = bind(this.saveToken, this);
      this.getToken = bind(this.getToken, this);
      SlackFilesService.__super__.constructor.apply(this, arguments);
    }

    SlackFilesService.prototype.getToken = function() {
      return this.http.post('backend/admin/slack-files/get-token');
    };

    SlackFilesService.prototype.saveToken = function(token) {
      return this.http.post('backend/admin/slack-files/save-token', {
        token: token
      });
    };

    SlackFilesService.prototype.getFiles = function() {
      return this.http.post('backend/admin/slack-files/get-files');
    };

    SlackFilesService.prototype.getUsers = function() {
      return this.http.post('backend/admin/slack-files/get-users');
    };

    SlackFilesService.prototype.deleteFile = function(file) {
      return this.http.post('backend/admin/slack-files/delete-file', {
        file: file
      });
    };

    return SlackFilesService;

  })(AngularService);

}).call(this);
